module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/ig-03-e932e4063fcfac183c8930eb0cfb07e4.jpg";